module.exports = __webpack_public_path__ + "static/media/eva_clock-outline-2.489abd05.svg";